module.exports = __webpack_public_path__ + "static/media/34DSS1.109aad5a.jpg";